import { useCallback, useEffect, useState } from "react";
import {
  readWalletBalanceVisible,
  WALLET_BALANCE_VISIBLE_KEY,
  WALLET_BALANCE_VISIBILITY_EVENT,
  writeWalletBalanceVisible,
} from "../helper/walletBalanceVisibility";

export const useWalletBalanceVisibility = () => {
  const [balanceVisible, setBalanceVisibleState] = useState(() =>
    readWalletBalanceVisible()
  );

  useEffect(() => {
    const syncFromStorage = () => {
      setBalanceVisibleState(readWalletBalanceVisible());
    };

    const onVisibilityEvent = (event: Event) => {
      const detail = (event as CustomEvent<boolean>).detail;
      if (typeof detail === "boolean") {
        setBalanceVisibleState(detail);
        return;
      }
      syncFromStorage();
    };

    const onStorage = (event: StorageEvent) => {
      if (event.key === WALLET_BALANCE_VISIBLE_KEY) {
        syncFromStorage();
      }
    };

    window.addEventListener(WALLET_BALANCE_VISIBILITY_EVENT, onVisibilityEvent);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(WALLET_BALANCE_VISIBILITY_EVENT, onVisibilityEvent);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  const setBalanceVisible = useCallback(
    (value: boolean | ((prev: boolean) => boolean)) => {
      setBalanceVisibleState((prev) => {
        const next = typeof value === "function" ? value(prev) : value;
        writeWalletBalanceVisible(next);
        return next;
      });
    },
    []
  );

  const toggleBalanceVisible = useCallback(() => {
    setBalanceVisible((prev) => !prev);
  }, [setBalanceVisible]);

  return { balanceVisible, setBalanceVisible, toggleBalanceVisible };
};
